import React, { ReactNode } from 'react';
import { Text, XStack, YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

interface TextSectionProps {
  primaryText?: string;
  secondaryText?: string;
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
  primaryIcon?: ReactNode;
  pillText?: string;
  primaryTextColor?: string;
  secondaryTextColor?: string;
}

export const TextSection: React.FC<TextSectionProps> = ({
  primaryText,
  secondaryText,
  justifyContent = 'center',
  primaryIcon,
  pillText,
  primaryTextColor,
  secondaryTextColor,
}) => (
  <YStack flex={1} justifyContent={justifyContent} space={4}>
    <XStack alignItems="center" space={12}>
      {primaryIcon && (
        <XStack width={48} height={48}>
          {primaryIcon}
        </XStack>
      )}
      <YStack>
        <Text
          color={primaryTextColor || tokens.color.white12}
          fontFamily="$heading"
          fontSize="$8"
          fontWeight="$9.5">
          {primaryText}
        </Text>

        {/* Pill badge */}
        {pillText && (
          <YStack
            backgroundColor={tokens.color.pillBackground}
            paddingVertical={8}
            paddingHorizontal={16}
            borderRadius={100}
            marginTop={4}
            alignSelf="flex-start">
            <Text color={tokens.color.white12} fontFamily="$body" fontSize="$9.5" fontWeight="$5">
              {pillText}
            </Text>
          </YStack>
        )}
      </YStack>
    </XStack>
    {secondaryText && (
      <Text
        color={secondaryTextColor || tokens.color.white10}
        fontFamily="$body"
        fontSize="$9.5"
        fontWeight="$4">
        {secondaryText}
      </Text>
    )}
  </YStack>
);
